import React from 'react';

import type { Icon } from './icon-types';

const DavidLloydLogoNew: Icon = ({ size, fill = '#231f0' }) => {
  return (
    <div style={{ width: size || '100%', height: 'auto' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 611.3 123.6"
        style={{ overflow: 'visible' }}
      >
        <g id="S">
          <path
            fill={fill}
            d="M393.03,116.96c2.21,1.36,5.45,2.5,8.85,2.5,5.05,0,8-2.67,8-6.53,0-3.57-2.04-5.62-7.21-7.61-6.24-2.21-10.1-5.45-10.1-10.84,0-5.96,4.94-10.39,12.37-10.39,3.92,0,6.75.91,8.46,1.87l-1.36,4.03c-1.25-.68-3.8-1.82-7.26-1.82-5.22,0-7.21,3.12-7.21,5.73,0,3.58,2.33,5.34,7.61,7.38,6.47,2.5,9.76,5.62,9.76,11.24,0,5.9-4.37,11.01-13.39,11.01-3.69,0-7.72-1.08-9.76-2.44l1.25-4.14Z"
          />
        </g>
        <g id="B">
          <path
            fill={fill}
            d="M345.93,85.23c2.16-.45,5.56-.79,9.02-.79,4.94,0,8.12.85,10.5,2.78,1.99,1.48,3.18,3.75,3.18,6.75,0,3.69-2.44,6.92-6.47,8.4v.11c3.63.91,7.89,3.92,7.89,9.59,0,3.29-1.31,5.79-3.24,7.66-2.67,2.44-6.98,3.58-13.22,3.58-3.41,0-6.02-.23-7.66-.45v-37.63ZM350.87,100.89h4.48c5.22,0,8.29-2.72,8.29-6.41,0-4.48-3.4-6.24-8.4-6.24-2.27,0-3.58.17-4.37.34v12.32ZM350.87,119.23c.96.17,2.38.23,4.14.23,5.11,0,9.82-1.87,9.82-7.43,0-5.22-4.48-7.38-9.88-7.38h-4.09v14.59Z"
          />
        </g>
        <g id="U">
          <path
            fill={fill}
            d="M297.13,84.72v22.65c0,8.57,3.8,12.2,8.91,12.2,5.68,0,9.31-3.75,9.31-12.2v-22.65h4.99v22.3c0,11.75-6.19,16.57-14.47,16.57-7.83,0-13.74-4.48-13.74-16.35v-22.53h4.99Z"
          />
        </g>
        <g id="L">
          <path fill={fill} d="M250.43,84.72h4.94v34.11h16.35v4.14h-21.28v-38.25Z" />
        </g>
        <g id="C">
          <path
            fill={fill}
            d="M227.23,121.72c-1.82.91-5.45,1.82-10.1,1.82-10.78,0-18.9-6.81-18.9-19.35s8.12-20.09,19.98-20.09c4.77,0,7.78,1.02,9.08,1.7l-1.19,4.03c-1.87-.91-4.54-1.59-7.72-1.59-8.97,0-14.93,5.73-14.93,15.78,0,9.37,5.39,15.38,14.7,15.38,3.01,0,6.07-.62,8.06-1.59l1.02,3.92Z"
          />
        </g>
        <g id="Left_Line">
          <rect fill={fill} x="114.72" y="99.97" width="63.75" height="4.36" />
        </g>
        <g id="Right_Line">
          <rect fill={fill} x="432.83" y="99.97" width="63.75" height="4.36" />
        </g>
        <g id="D">
          <path
            fill={fill}
            d="M579.86.53h-20.58v58.8h20.35c18.05,0,31.66-12.77,31.66-29.7s-12.93-29.1-31.44-29.1ZM601.13,29.63c0,16.77-8.44,27.6-21.5,27.6h-10.49V2.63h10.86c13.22,0,21.12,10.09,21.12,27Z"
          />
        </g>
        <g id="Y">
          <polygon
            fill={fill}
            points="542.69 .53 539.09 .53 522.95 22.8 506.52 .53 494.48 .53 513.69 26.54 513.69 59.33 523.56 59.33 523.56 26.71 542.69 .53"
          />
        </g>
        <g id="O">
          <path
            fill={fill}
            d="M451.07,0c-17.04,0-30.38,13.15-30.38,29.93s12.78,29.93,30.38,29.93,30.31-13.21,30.31-30.08S468.35,0,451.07,0ZM451.07,2.1c12.8,0,20.14,10.14,20.14,27.83s-7.53,27.83-20.14,27.83-20.21-10.14-20.21-27.83,7.37-27.83,20.21-27.83Z"
          />
        </g>
        <g id="L1" data-name="L">
          <polygon
            fill={fill}
            points="388.52 .53 378.66 .53 378.66 59.33 414.31 59.33 414.31 56.23 388.52 56.23 388.52 .53"
          />
        </g>
        <g id="L2" data-name="L">
          <polygon
            fill={fill}
            points="335.18 .53 325.32 .53 325.32 59.33 360.97 59.33 360.97 56.23 335.18 56.23 335.18 .53"
          />
        </g>
        <g id="D1" data-name="D">
          <path
            fill={fill}
            d="M248.12.53h-20.58v58.8h20.35c18.05,0,31.66-12.77,31.66-29.7S266.63.53,248.12.53ZM269.39,29.63c0,16.77-8.44,27.6-21.5,27.6h-10.49V2.63h10.86c13.22,0,21.12,10.09,21.12,27Z"
          />
        </g>
        <g id="I">
          <rect fill={fill} x="192.54" y=".53" width="9.86" height="58.8" />
        </g>
        <g id="V">
          <polygon
            fill={fill}
            points="153.12 59.33 148.54 59.33 123.53 .53 134.25 .53 154.55 48.15 174.48 .53 177.75 .53 153.12 59.33"
          />
        </g>
        <g id="A">
          <polygon
            fill={fill}
            points="83.91 .53 86.29 6.05 63.25 59.33 66.53 59.33 87.74 9.73 109.23 59.33 120.18 59.33 94.78 .53 83.91 .53"
          />
        </g>
        <g id="D2" data-name="D">
          <path
            fill={fill}
            d="M20.58.53H0v58.8h20.35c18.05,0,31.66-12.77,31.66-29.7S39.09.53,20.58.53ZM41.85,29.63c0,16.77-8.44,27.6-21.5,27.6h-10.49V2.63h10.86c13.22,0,21.12,10.09,21.12,27Z"
          />
        </g>
      </svg>
    </div>
  );
};

export default DavidLloydLogoNew;
